const root = document.getElementById("app");
if (!root) throw new Error("Missing #app root element");
const params = new URLSearchParams(window.location.search);

// Whitelist for any user-supplied trackSlug — kebab-case lowercase + digits.
// Rejects HTML/script payloads at the URL boundary before they ever reach
// the DOM or fetch().
const SLUG_PATTERN = /^[a-z0-9-]+$/;

switch (params.get("page")) {
  case "analyze-beats": {
    // Beat analysis is a build-time/dev-only tool. Hide the route in
    // production builds so end users can't load essentia.js or the
    // analyze UI even if they guess the URL.
    if (!import.meta.env.DEV) {
      root.innerHTML = `<p style="color:#fff;padding:24px">Not found.</p>`;
      break;
    }
    const trackSlug = params.get("track");
    if (!trackSlug) {
      root.innerHTML = `<p style="color:#fff;padding:24px">Add &track=&lt;slug&gt; to URL.</p>`;
      break;
    }
    if (!SLUG_PATTERN.test(trackSlug)) {
      root.innerHTML = `<p style="color:#fff;padding:24px">Invalid track slug. Must match ${SLUG_PATTERN.source}.</p>`;
      break;
    }
    import("./pages/analyze-beats").then((m) => m.runAnalyzeBeats(root, trackSlug));
    break;
  }
  case "audio-demo":
    import("./pages/audio-demo").then((m) => m.runAudioDemo(root));
    break;
  case "calibration":
    import("./pages/calibration-demo").then((m) =>
      m.runCalibrationDemo(root).catch((err) => console.error("Calibration failed:", err)),
    );
    break;
  case "world-test": {
    // Dev-only visual gate. Hidden in production so SyntheticEventSource and the
    // __world inspection hook never ship to end users.
    if (!import.meta.env.DEV) {
      root.innerHTML = `<p style="color:#fff;padding:24px">Not found.</p>`;
      break;
    }
    Promise.all([import("./world/game-world"), import("./world/synthetic-event-source")])
      .then(async ([{ GameWorld }, { SyntheticEventSource }]) => {
        const world = new GameWorld(root, { eventSource: new SyntheticEventSource() });
        await world.init();
        (window as unknown as { __world?: unknown }).__world = world;
        // Inline keyboard input for the dev gate (GameWorld no longer auto-wires).
        const onKey = (e: KeyboardEvent) => {
          if (e.code !== "Space") return;
          if (e.repeat) return;
          if (e.metaKey || e.ctrlKey || e.altKey) return;
          e.preventDefault();
          world.player.physics.jump(performance.now() / 1000);
        };
        window.addEventListener("keydown", onKey);
      })
      .catch((err) => console.error("World init failed:", err));
    break;
  }
  case "game":
    import("./pages/game")
      .then((m) => m.runGame(root))
      .catch((err) => {
        console.error("Game failed:", err);
        root.innerHTML = `<p style="color:#f44;padding:24px">Game failed to start. Check console.</p>`;
      });
    break;
  default:
    root.innerHTML = `
      <div style="color:#fff;font-family:sans-serif;padding:24px">
        <h1>Rhythm Runner — dev</h1>
        <ul>
          <li><a href="?page=game" style="color:#0ff">Play game</a></li>
          <li><a href="?page=audio-demo" style="color:#8af">Audio demo (curated track)</a></li>
          <li><a href="?page=calibration" style="color:#8af">Calibration test (calibration gate)</a></li>
          <li><a href="?page=world-test" style="color:#8af">World render test (Pixi visual gate)</a></li>
          <li><a href="?page=analyze-beats&track=retro-synths" style="color:#8af">Analyze beats (dev)</a></li>
        </ul>
      </div>`;
}
